import React from 'react';
import { Link } from 'react-router-dom';

const Government = () => {
  // Styles
  const sectionTitleStyle = {
      color: '#003366', 
      borderBottom: '2px solid #003366', 
      paddingBottom: '10px', 
      marginBottom: '20px',
      fontSize: '18px',
      fontFamily: 'serif',
      textTransform: 'uppercase',
      fontWeight: 'bold'
  };

  const blueCardStyle = {
      backgroundColor: '#003366',
      color: 'white'
  };

  // --- NEW: Data object for the main minister ---
  // Is data ko hum Link ke zariye pass karenge
  const mainMinisterData = {
    id: 'dorin-recean', // Unique ID for URL route
    name: 'DORIN RECEAN',
    title: 'PRIM-MINISTRU',
    roleEnglish: 'Prime Minister of the Republic of Moldova',
    image: '/images/20251229-1ES_5784.jpg', // Wahi same image path
    descriptionItems: [
        'Economist și specialist în analiza datelor',
        'Are experiență de peste 27 de ani în sectorul public și privat...',
        'Consilier al Președintelui Republicii Moldova în domeniul apărării...'
    ]
  };

  return (
    <div className="container mt-4 mb-5">
      {/* CSS for image hover effect (Optional but good for UX) */}
      <style>
        {`
          .hover-zoom-img {
            transition: transform 0.3s ease;
          }
          .clickable-image-container:hover .hover-zoom-img {
            transform: scale(1.03);
          }
        `}
      </style>

      <div className="row">
        
        {/* === LEFT: MENU === */}
        <div className="col-lg-3">
            <h4 style={sectionTitleStyle}>GOVERNMENT</h4>
            <div className="list-group list-group-flush">
                <a href="#" className="list-group-item list-group-item-action fw-bold text-primary border-0 ps-0" style={{fontSize:'14px'}}>
                    <i className="fa fa-chevron-right me-2 text-secondary" style={{fontSize:'10px'}}></i> Cabinet of Ministers
                </a>
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0" style={{fontSize:'14px'}}>
                    <i className="fa fa-chevron-right me-2 text-secondary" style={{fontSize:'10px'}}></i> Deputy Prime Minister for reintegration
                </a>
                {/* ... other links ... */}
            </div>
        </div>

        {/* === CENTER: CABINET === */}
        <div className="col-lg-6">
            <h4 style={sectionTitleStyle}>CABINET OF MINISTERS</h4>
            <div className="card border-0 mb-4 shadow-sm overflow-hidden bg-white">
                <div className="row g-0">
                    {/* === CLICKABLE IMAGE SECTION === */}
                    <div className="col-md-5 clickable-image-container" style={{ overflow: 'hidden' }}>
                        {/* LINK COMPONENT:
                           1. 'to': Kahan jana hai (e.g., /minister/dorin-recean)
                           2. 'state': Data jo sath le jana hai (wahi image aur description)
                        */}
                        <Link 
                          to={`/government/minister/${mainMinisterData.id}`} 
                          state={{ ministerData: mainMinisterData }}
                          className="d-block h-100"
                          style={{ cursor: 'pointer' }}
                        >
                          <img 
                              src={mainMinisterData.image} 
                              className="img-fluid h-100 w-100 hover-zoom-img" 
                              style={{objectFit: 'cover'}} 
                              alt={mainMinisterData.name}
                          />
                        </Link>
                    </div>

                    {/* TEXT SECTION (Reads from data object) */}
                    <div className="col-md-7 p-4 d-flex flex-column justify-content-center">
                        <div className="mb-3">
                             <h3 className="text-uppercase mb-0" style={{color: '#003366', fontFamily: 'serif', fontWeight: 'bold'}}>{mainMinisterData.name}</h3>
                             <small className="text-uppercase text-muted fw-bold" style={{fontSize: '12px', letterSpacing: '1px'}}>{mainMinisterData.title}</small>
                        </div>
                        <ul className="ps-3 mb-4 text-secondary" style={{fontSize:'13px', lineHeight:'1.5'}}>
                            {mainMinisterData.descriptionItems.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        <div>
                            <h4 className="text-uppercase mb-0" style={{color: '#003366', fontFamily: 'serif'}}>{mainMinisterData.name}</h4>
                            <p className="text-secondary mb-0" style={{fontSize: '14px'}}>{mainMinisterData.roleEnglish}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Small Cards (These are not clickable yet, as per request to focus on the main one) */}
            <div className="row g-3">
                <div className="col-4">
                    <div className="card border-0 h-100 text-center" style={blueCardStyle}>
                        <img src="/images/20251229-1ES_4843.jpg" className="card-img-top" style={{height:'150px', objectFit:'cover'}} alt="Minister"/>
                        <div className="card-body p-2"><h6 className="mb-1 fw-bold text-white" style={{fontSize: '12px'}}>Cristina Gherasimov</h6></div>
                    </div>
                </div>
                <div className="col-4">
                      <div className="card border-0 h-100 text-center" style={blueCardStyle}>
                        <img src="/images/20251229-_ES29651.jpg" className="card-img-top" style={{height:'150px', objectFit:'cover'}} alt="Minister"/>
                        <div className="card-body p-2"><h6 className="mb-1 fw-bold text-white" style={{fontSize: '12px'}}>Mihai Popșoi</h6></div>
                    </div>
                </div>
                <div className="col-4">
                      <div className="card border-0 h-100 text-center" style={blueCardStyle}>
                        <img src="/images/20251229-1ES_4993.jpg" className="card-img-top" style={{height:'150px', objectFit:'cover'}} alt="Minister"/>
                        <div className="card-body p-2"><h6 className="mb-1 fw-bold text-white" style={{fontSize: '12px'}}>Oleg Serebrian</h6></div>
                    </div>
                </div>
            </div>
        </div>

        {/* === RIGHT: WIDGETS === */}
        <div className="col-lg-3">
           {/* ... Calendar Widget Section ... */}
            <h4 style={sectionTitleStyle}>AGENDA</h4>
            <div className="bg-white border rounded shadow-sm p-0 mb-4">
                <div className="d-flex justify-content-between align-items-center text-white p-2" style={{backgroundColor: '#003366'}}>
                    <span className="fw-bold" style={{fontSize:'14px'}}>January 2026</span>
                </div>
                <div className="p-2">
                    <table className="table table-sm text-center border-0 mb-0" style={{fontSize: '12px'}}>
                        <thead>
                            <tr style={{color: '#003366'}}>
                                <th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th><th>S</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Week 1: Dec 29 - Jan 4 (Jan 1 starts on Thursday) */}
                            <tr>
                                <td className="text-muted opacity-25">29</td>
                                <td className="text-muted opacity-25">30</td>
                                <td className="text-muted opacity-25">31</td>
                                <td>1</td>
                                <td>2</td>
                                <td>3</td>
                                <td>4</td>
                            </tr>
                            {/* Week 2: Jan 5 - 11 */}
                            <tr>
                                <td>5</td>
                                <td>6</td>
                                <td>7</td>
                                <td>8</td>
                                <td>9</td>
                                <td>10</td>
                                <td>11</td>
                            </tr>
                            {/* Week 3: Jan 12 - 18 */}
                            <tr>
                                <td>12</td>
                                <td>13</td>
                                <td>14</td>
                                <td>15</td>
                                <td>16</td>
                                <td>17</td>
                                <td>18</td>
                            </tr>
                            {/* Week 4: Jan 19 - 25 */}
                            <tr>
                                <td>19</td>
                                <td>20</td>
                                {/* Aaj ki date (21) ko highlight kar diya hai example ke liye */}
                                <td className="bg-primary text-white rounded-circle" style={{width: '25px'}}>21</td>
                                <td>22</td>
                                <td>23</td>
                                <td>24</td>
                                <td>25</td>
                            </tr>
                            {/* Week 5: Jan 26 - Feb 1 */}
                            <tr>
                                <td>26</td>
                                <td>27</td>
                                <td>28</td>
                                <td>29</td>
                                <td>30</td>
                                <td>31</td>
                                <td className="text-muted opacity-25">1</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
      </div>
    </div>
  );
};

export default Government;